import React from 'react';
import { useInView } from 'react-intersection-observer';

import PageSection from '../PageSections/PageSection';
import { ArrowLink } from './Links';
import * as styles from './Reviews.module.scss';
import RichTextConverter from './RichText/RichTextConverter';

export default function Reviews({ content, backgroundColor, slim = true }) {
  const { ref, inView } = useInView({
    threshold: 0.25,
    triggerOnce: true,
  });

  return (
    <PageSection slim={slim} className={styles[backgroundColor]} data-analytics-section={'reviews-section'}>
      <div ref={ref} className={[styles.reviews, inView ? styles.visible : ''].join(' ')}>
        {content.map((review, i) => (
          <div key={i} className={styles.review} data-analytics-component={'review'} data-analytics-id={review.title}>
            <img className={styles.image} src={review.image?.file?.url} alt="5-star rating" />
            <h3>{review.title}</h3>
            <RichTextConverter copy={review.body} />
            <ArrowLink className={styles.cta} hoverAnimation={true} label={review.linkLabel} url={review.linkUrl} />
          </div>
        ))}
      </div>
    </PageSection>
  );
}
